import { useSearchParams } from 'react-router-dom'
import AddSelfAssessmentPage from './AddSelfAssessmentPage'
import SelfAssessmentFilingPage from './SelfAssessmentFilingPage'

/**
 * Single entry point for the Self-Assessment flow (mirrors CT600's single
 * `/ct600-filing` route).
 *
 * Until a NINO and flow have been chosen, this renders the launcher
 * ({@link AddSelfAssessmentPage}: NINO entry, flow/plan selection, draft
 * resume) as step one. Once both are present in the URL it renders the wizard
 * ({@link SelfAssessmentFilingPage}). Both the canonical `/self-assessment/filing`
 * route and the legacy `/add-self-assessment` alias resolve here, so existing
 * deep links (HMRC auth redirects, payment cancel URLs, history, back buttons)
 * continue to work unchanged.
 */
export default function SelfAssessmentEntry() {
  const [searchParams] = useSearchParams()
  const hasStarted = !!searchParams.get('nino') && !!searchParams.get('flow')

  return hasStarted ? <SelfAssessmentFilingPage /> : <AddSelfAssessmentPage />
}
